var map = {
	"./ccf-de-DE.png": "acce",
	"./ccf-en-US.png": "fbb9",
	"./ccf-es-ES.png": "b8af",
	"./ccf-fr-FR.png": "d5be",
	"./ccf-ja-JP.png": "5b63",
	"./ccf-ko-KR.png": "23a3",
	"./ccf-pt-PT.png": "0464",
	"./ccf-vi-VN.png": "ae70",
	"./ccf-zh-CN.png": "4d06",
	"./ccf-zh-TW.png": "ceda"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ead7";